const listeners = new Set();
let state = { sessionId: null, runs: [], loading: false, error: null };

export function getRunState() { return state; }
export function beginLoad(sessionId) { state = { sessionId, runs: state.sessionId === sessionId ? state.runs : [], loading: true, error: null }; emit(); }
export function setRuns(sessionId, runs) { state = { sessionId, runs: Array.isArray(runs) ? runs : [], loading: false, error: null }; emit(); }
export function setError(sessionId, error) { state = { sessionId, runs: [], loading: false, error: error?.message || "任务加载失败" }; emit(); }
export function clearRuns() { state = { sessionId: null, runs: [], loading: false, error: null }; emit(); }

export function upsertRun(run) {
  if (!run?.runId) return;
  const idx = state.runs.findIndex((item) => item.runId === run.runId);
  const runs = idx < 0 ? [run, ...state.runs] : state.runs.map((item, index) => index === idx ? { ...item, ...run } : item);
  state = { ...state, sessionId: run.sessionId || state.sessionId, runs };
  emit();
}

export function subscribe(listener) { listeners.add(listener); listener(state); return () => listeners.delete(listener); }
function emit() { for (const listener of listeners) listener(state); }
export const runStore = Object.freeze({ getRunState, beginLoad, setRuns, setError, clearRuns, upsertRun, subscribe });
